import { emailSanitizationProfile } from './profiles/channels/emailSanitizationProfile';
import { whatsAppSanitizationProfile } from './profiles/channels/whatsAppSanitizationProfile';
import { widgetChatSanitizationProfile } from './profiles/channels/widgetChatSanitizationProfile';
import { plainTextSanitizationProfile } from './profiles/plainTextSanitizationProfile';

/** Represents the available sanitization profiles. */
export const sanitizationProfiles = {
  plainText: plainTextSanitizationProfile,

  /** The channels specific profiles. */
  email: emailSanitizationProfile,
  widgetChat: widgetChatSanitizationProfile,
  whatsApp: whatsAppSanitizationProfile,
};
